<template>
  <div
    :class="[
      $style.marketingBanner,
      gradientBackground && $style.gradientBackground,
      bgImage && $style.backgroundImage,
    ]"
    :style="[{'background-image': bgImage && `url(${bgImage})` }]"
  >
    <b-svg
      v-if="svgTop"
      :name="svgTop"
      :class="[$style.svg, 'mb-4']"
      :size="80"
    />

    <div class="flex mb-3">
      <div class="mr-4">
        <div v-if="title" :class="$style.title">
          {{ title }}
        </div>
        <div v-if="description" class="b-font-h6">
          {{ description }}
        </div>
      </div>
      <b-svg
        v-if="svgRight"
        :name="svgRight"
        :class="[$style.svg, 'ml-auto']"
        :size="80"
      />
      <img
        v-if="imageRight"
        width="80"
        height="80"
        class="ml-auto"
        :src="imageRight"
      />
    </div>

    <slot name="buttons"/>
  </div>
</template>

<script setup lang="ts">
defineOptions({
  name: 'b-marketing-banner',
})

withDefaults(
  defineProps<{
    title?: string | null
    description?: string | null
    gradientBackground?: boolean
    bgImage?: string | null
    svgTop?: string | null
    svgRight?: string | null
    imageRight?: string | null
  }>(),
  {
    title: null,
    description: null,
    gradientBackground: false,
    bgImage: null,
    svgTop: null,
    svgRight: null,
    imageRight: null,
  }
)
</script>

<style lang="scss" module>
@layer legacy-views {

.marketingBanner {
  border-radius: 8px;
  padding: 16px;
  background-color: var(--color-bg-primary);

  .title {
    font-weight: 600;
    padding-bottom: 4px;
  }
}

.gradientBackground {
  background: var(--b-gradient-purple)
}

.backgroundImage {
  background-repeat: no-repeat;
  background-position: right top;
}

.svg {
  min-width: 80px;
  max-width: 80px;
}

}</style>
